module.exports = __webpack_public_path__ + "static/media/bb.15cb2720.svg";